import { EventEmitter } from "@angular/core";
import { getEmptyField } from "@core/_utils/tools.utils";
import { LineResult } from "./line-result";

export class HeaderResult {
    id: number;
    name: string;
    desc: string;
    visibility: any;
    listVisibility: any[];
    userListUsed: any[];
    groupListUsed: any[];
    reqDetail: any[];

    notifyParent: EventEmitter<any> = new EventEmitter(); 

    public Clear() {
        this.id = 0;
        this.name = '';
        this.desc = '';
        this.visibility = null;
        this.listVisibility = [];
        this.userListUsed = [];
        this.groupListUsed = [];
        this.reqDetail = [];
    }
    public loadVisibility(atype, avisibility) {
        for (let i = 0; i < avisibility.length; i++) {
            this.listVisibility.push({label: avisibility[i].name,
                value: {id: avisibility[i].id, name: avisibility[i].name}});
        }
    }

    public load(adata){
        this.id = adata.id;
        this.name = adata.label;
        this.desc = adata.description;
        this.visibility = adata.visibility;
        if (this.visibility === 1) {
            this.groupListUsed = [...this.getAccessList(adata)];
        }
        if (this.visibility === 2) {
            this.userListUsed = [...this.getAccessList(adata)];
        }
        this.reqDetail = this.getResDetail(adata);
        this.notifyParent.emit();
    }  

    public getResDetail(adata) {
        let wReqDetail = [];
        if (adata.webResultDetails.length > 0) {
            for (let i = 0; i < adata.webResultDetails.length; i++) {
                let witem = new LineResult();
                witem.Name = adata.webResultDetails[i].name;
                if (adata.webResultDetails[i].label === null) {
                    witem.Label = witem.Name;
                } else {
                    witem.Label = adata.webResultDetails[i].label;
                }
                witem.NumOrder = adata.webResultDetails[i].numorder;
                witem.TypeOrder = adata.webResultDetails[i].typeorder;
                witem.Type = adata.webResultDetails[i].type;
                witem.ThumbInfo = getEmptyField(adata.webResultDetails[i].thumbinfo);
                witem.noligne = i;
                wReqDetail.push(witem);
            }
        }
        return wReqDetail;
    }

    private getAccessList(adata) {
        let wAccessList = [];
        if (adata.webResultVisibilities.length > 0) {
            for (let i = 0; i < adata.webResultVisibilities.length; i++) {
                wAccessList.push(adata.webResultVisibilities[i].name);
            }
        }
        return wAccessList;
    }

}